<template>
  <span>
    <template v-if="isWhiteLabelClient">
      <v-footer color="transparent" :class="auth ? 'public-footer' : 'px-6'">
        <div
          class="
            public-footer__inner public-footer__inner--white-label
            text-secondary
          "
        >
          <p class="public-footer__text">
            {{ whiteLabelFooterSubtitle }}
          </p>
          <p class="public-footer__text public-footer__copyright">
            {{
              $t("publicPages.footer.copyright", {
                year: new Date().getFullYear(),
              })
            }}
          </p>
        </div>
      </v-footer>
    </template>

    <template v-else-if="auth">
      <v-footer color="transparent" class="public-footer">
        <div class="public-footer__inner text-secondary">
          <p class="public-footer__text public-footer__copyright">
            © {{ new Date().getFullYear() }}
            {{ $t("publicPages.footer.by") }}
            <a
              href="https://objetivar.com.br"
              class="text-decoration-none btn-hover text-primary"
              target="_blank"
              >Objetivar Sistemas</a
            >
          </p>

          <nav class="public-footer__links">
            <a
              v-for="item in localizedFooter"
              :key="item.linkName"
              :href="item.link"
              class="text-decoration-none"
              target="_blank"
              >{{ item.linkName }}</a
            >
          </nav>

          <div class="public-footer__social">
            <a
              v-for="item in icons"
              :key="item.icon"
              :href="item.link"
              :aria-label="item.label"
              class="text-decoration-none"
              target="_blank"
            >
              <v-icon size="17" color="inherit">{{ item.icon }}</v-icon>
            </a>
          </div>
        </div>
      </v-footer>
    </template>

    <template v-else>
      <v-footer color="transparent" class="px-6">
        <v-card class="flex" color="transparent">
          <v-card-text class="px-0">
            <v-row>
              <v-col cols="12" md="6">
                <div class="copyright text-body-2 ls-0 text-muted">
                  © {{ new Date().getFullYear() }},
                  {{ $t("publicPages.footer.by") }}
                  <a
                    href="https://objetivar.com.br"
                    class="
                      text-decoration-none text-typo text-body-2
                      ls-0
                      font-weight-bold
                    "
                    target="_blank"
                    >Objetivar Sistemas</a
                  >
                </div>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="
                  d-flex
                  flex-wrap
                  justify-center justify-md-end
                  dashboard-footer-links
                "
              >
                <ul
                  v-for="item in localizedFooter"
                  :key="item.linkName"
                  class="d-flex list-style-none"
                >
                  <li>
                    <a
                      :href="item.link"
                      class="
                        text-decoration-none text-muted text-body-2
                        ls-0
                        btn-dark-hover
                        no-default-hover
                      "
                      target="_blank"
                      >{{ item.linkName }}</a
                    >
                  </li>
                </ul>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-footer>
    </template>
  </span>
</template>
<script>
import {
  getLocalizedWhiteLabelText,
  isClientWhiteLabel,
} from "@/utils/whiteLabel";

export default {
  name: "content-footer",
  props: {
    auth: Boolean,
    whiteLabelBrand: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      footer: [
        {
          translationKey: "publicPages.footer.apiDocumentation",
          link: "https://appcajupe.com:8443/swagger-ui.html",
        },
        {
          translationKey: "publicPages.footer.aboutUs",
          link: "https://objetivar.com.br/quem-somos/",
        },
        {
          translationKey: "publicPages.footer.privacyPolicy",
          link: "https://objetivar.com.br/politica-de-privacidade-2/",
        },
      ],
      icons: [
        // {
        //   icon: "fab fa-dribbble",
        // },
        // {
        //   icon: "fab fa-twitter",
        // },
        {
          icon: "fab fa-instagram",
          label: "Instagram",
          link: "https://www.instagram.com/appcajupe/",
        },
        {
          icon: "fab fa-linkedin",
          label: "LinkedIn",
          link: "https://www.linkedin.com/company/cajupe%C2%AE%EF%B8%8F/",
        },
        {
          icon: "fab fa-brands fa-youtube",
          label: "YouTube",
          link: "https://www.youtube.com/@cajupe",
        },
        //   {
        //     icon: "fab fa-github",
        //   },
      ],
    };
  },
  computed: {
    localizedFooter() {
      return this.footer.map((item) => ({
        ...item,
        linkName: this.$t(item.translationKey),
      }));
    },
    isWhiteLabelClient() {
      return isClientWhiteLabel(this.whiteLabelBrand);
    },
    whiteLabelFooterSubtitle() {
      return getLocalizedWhiteLabelText(
        this.whiteLabelBrand,
        "landingSubtitle",
        this.$i18n
      );
    },
  },
};
</script>

<style scoped>
.dashboard-footer-links {
  gap: 8px 16px;
  min-width: 0;
}

.dashboard-footer-links ul {
  margin: 0;
  padding: 0;
  max-width: 100%;
}

.public-footer {
  margin-top: 1.5rem;
  padding: 0.75rem 1rem;
}

.public-footer__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.25rem 1rem;
  width: 100%;
  font-size: 0.9375rem;
  line-height: 1.4;
  text-align: center;
}

.public-footer__links a,
.public-footer__social a {
  color: inherit;
}

.public-footer__inner a:hover {
  opacity: 0.75;
}

.public-footer__text {
  margin: 0;
  letter-spacing: 0;
}

.public-footer__copyright {
  white-space: nowrap;
}

.public-footer__copyright a {
  font-weight: 600;
}

.public-footer__links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.125rem 1rem;
}

.public-footer__links a {
  white-space: nowrap;
}

.public-footer__social {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.public-footer__social a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

/* Celular: links em cima, copyright + redes sociais na linha de baixo */
@media (max-width: 767px) {
  .public-footer__inner {
    font-size: 0.875rem;
    column-gap: 0.75rem;
  }

  .public-footer__links {
    order: -1;
    flex-basis: 100%;
    column-gap: 0.75rem;
  }

  .public-footer__social {
    gap: 0;
  }

  .public-footer__social a {
    width: 28px;
    height: 28px;
  }
}

/* Tablet/desktop: tudo em uma única linha */
@media (min-width: 768px) {
  .public-footer__inner {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    gap: 1.5rem;
    text-align: left;
  }

  .public-footer__inner--white-label {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .public-footer__inner--white-label .public-footer__copyright {
    text-align: right;
  }
}

/* Tablet: compacta um pouco para caber na mesma linha */
@media (min-width: 768px) and (max-width: 1023px) {
  .public-footer__inner {
    font-size: 0.875rem;
    gap: 0.75rem;
  }

  .public-footer__links {
    column-gap: 0.625rem;
  }

  .public-footer__social {
    gap: 0;
  }
}
</style>
